import { FC, useRef, useEffect, HTMLAttributes } from 'react'
import { Omit } from 'interfaces'

type FocusinHandlerProps =
  & Omit<HTMLAttributes<HTMLDivElement>, 'onFocus' | 'onBlur'>
  & {
    onFocus?: () => void
    onBlur?: () => void
    className?: string
  }
export const FocusinHandler: FC<FocusinHandlerProps> = (props) => {
  const { children, onFocus, onBlur, ...restProps } = props

  const ref = useRef<HTMLDivElement>(null)
  useEffect(() => {
    const { current } = ref
    if (!current) {
      return
    }


    onFocus && current.addEventListener('focusin', onFocus, false)
    onBlur && current.addEventListener('focusout', onBlur, false)

    return () => {
      onFocus && current.removeEventListener('focusin', onFocus, false)
      onBlur && current.removeEventListener('focusout', onBlur, false)
    }
  }, [onBlur, onFocus])

  return (
    <div ref={ ref } { ...restProps }>
      { children }
    </div>
  )
}
